export interface ValidationMappingResult {
  fieldErrors: string[]
  customError: Record<string, string>
}

/**
 * 🔄 mapInvalidFields: Maps API validation errors to UI state format
 * Transforms server invalid_fields object into fieldErrors array and customError map
 * No longer strips form section prefixes; uses keys as-is
 */
export const mapInvalidFields = (
  invalidFields: Record<string, string | string[]>
): ValidationMappingResult => {
  console.log(
    '🔄 mapInvalidFields: mapping API validation errors',
    invalidFields
  )

  const fieldErrorsSet = new Set<string>()
  const customError: Record<string, string> = {}

  Object.keys(invalidFields).forEach((key) => {
    // Use the key as-is, no transformation
    console.log('🔄 mapInvalidFields: Processing field error', {
      key,
    })
    fieldErrorsSet.add(key)
    // Handle both string and string[] (new API format)
    const value = invalidFields[key]
    customError[key] = Array.isArray(value) ? value[0] ?? '' : value
  })

  return {
    fieldErrors: Array.from(fieldErrorsSet),
    customError,
  }
}
